import { apiFetch } from '../api';

export const getProductList = () => {
  return apiFetch(`/Products/Search`);
};

export const getProductListCombo = () => {
  return apiFetch(`/Products/ForCombo?includeSelect=false`);
};

export const saveProductAPI = (payload) => {
  return apiFetch(`/Products/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteProductAPI = (ProductGUID) => {
  return apiFetch(`/Products/Delete?id=${ProductGUID}`, {
    method: 'POST'
  });
};

/* ── Issues API Calls ─────────────────────────────────────────────────────── */

export const getIssuesList = (payload) => {
  return apiFetch(`/IssueDetails/Search`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const saveIssuesAPI = (payload) => {
  return apiFetch(`/IssueDetails/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteIssuesAPI = (issueGUID) => {
  return apiFetch(`/Issues/Delete?IssueGUID=${issueGUID}`, {
    method: 'POST'
  });
};

export const getStatusCombo = () => {
  return apiFetch(`/Issues/GetStatusCombo?includeSelect=false`);
};

export const getPriorityCombo = () => {
  return apiFetch(`/Issues/GetPriorityCombo?includeSelect=false`);
};

export const getUsersCombo = () => {
  return apiFetch(`/Issues/GetUsersCombo?includeSelect=false`);
};
